// frontend/src/pages/Settings.jsx
import React from 'react'
import { motion } from 'framer-motion'
import { Settings as SettingsIcon } from 'lucide-react'

const Settings = () => {
  return (
    <div className="h-full flex flex-col bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
            <SettingsIcon className="h-6 w-6 text-gray-600" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Settings</h1>
            <p className="text-sm text-gray-500">Configure your preferences</p>
          </div>
        </div>
      </div>
      
      <div className="flex-1 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <SettingsIcon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-600 mb-2">
            Settings Coming Soon
          </h2>
          <p className="text-gray-500">
            This feature is under development.
          </p>
        </motion.div>
      </div>
    </div>
  )
}

export default Settings